import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class SkillsService {

  constructor(public http: HttpClient, public AppConfig: AppConfig) { }

  getCountries() {
    return this.http.get('../assets/json/countries.json').pipe(map((response: any) => response));
  }

  getStates() {
    return this.http.get('../assets/json/allstates.json').pipe(map((response: any) => response));
  }

  getCities() {
    return this.http.get('../assets/json/in.json').pipe(map((response: any) => response));
  }

  getAllCities() {
    return this.http.get('../assets/json/cities.json').pipe(map((response: any) => response));
  }

  skillsEnquire(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT + 'SkillsEnquiriesPost', obj, httpOptions)
      .pipe(map((response: any) => response));
  }

  ieltsEnquiry(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post(this.AppConfig.API_ENDPOINT + 'IeltsCounsellingForm', obj, httpOptions)
      .pipe(map((response: any) => response));
  }

  speakToExpert(obj: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'secret': '6669ac7eeb6f363a778463e0',
        'token': '6669ac7eeb6f363a778463e0'
      })
    };
    return this.http.post('https://itech-api-prod.iquanta.in/api/igrowth/v1/phone/sent/enquiry', obj, httpOptions)
      .pipe(map((response: any) => response));
  }

  getSkillsExpertLeads() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'secret': '6669ac7eeb6f363a778463e0',
          'token': '6669ac7eeb6f363a778463e0'
      })
    };
  
    return this.http.get('https://itech-api-prod.iquanta.in/api/igrowth/v1/phone/all/growth/:page/:limit', httpOptions)
      .pipe(map((response: any) => response));
  }

}
